var map = {
	"./Announcements.vue": 98473,
	"./ArbitrageCalculator.vue": 66100,
	"./ArbitrageCalculatorHistory.vue": 83691,
	"./AssetPrice.vue": 93893,
	"./CalendarAnnouncements.vue": 58265,
	"./CryptoToStockIndexes.vue": 92789,
	"./DexVsCex.vue": 91865,
	"./Dominance.vue": 53299,
	"./FearGreed.vue": 89412,
	"./FundingRate.vue": 34040,
	"./FundingRateHistory.vue": 48408,
	"./OrderbookWalls.vue": 47436,
	"./PoWTokens.vue": 87082,
	"./Ratio.vue": 58307,
	"./SpotExchanges.vue": 83259,
	"./SymbolStatistics.vue": 56675,
	"./TechAnalysis.vue": 98542,
	"./Technicals.vue": 98502,
	"./VolumeByExchange.vue": 75398,
	"./VolumeByPrice.vue": 90230,
	"./VolumeByTime.vue": 69920,
	"./VolumesWAP.vue": 69538
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64290;